import { lazyComponent } from "@/client/lib/lazy-component";

// Parts of a screen its first frame seldom draws, out of that screen's first load
// (`scripts/client-budget.ts`). Each loads with the moment that draws it, and `every-chunk.ts`
// holds them for the session like the screens themselves.

// Tasks is the tab a person opens on.
export const monthForPerson = lazyComponent(() =>
  import("@/features/attendance/components/month-for-person").then(
    (m) => m.MonthForPerson,
  ),
);

export const personLeave = lazyComponent(() =>
  import("@/features/leave/components/person-leave").then((m) => m.PersonLeave),
);

export const payTab = lazyComponent(() =>
  import("@/features/payslips/components/pay-tab").then((m) => m.PayTab),
);

// The project page's display menu, with the select and switch primitives.
export const displayOptions = lazyComponent(() =>
  import("@/features/tasks/components/display-options").then(
    (m) => m.DisplayOptions,
  ),
);

// Home's question about a check-out someone missed, asked on few mornings.
export const missedCheckOutCard = lazyComponent(() =>
  import("@/features/attendance/components/missed-check-out-card").then(
    (m) => m.MissedCheckOutCard,
  ),
);

// Above every screen for an Admin, only while the plan needs them to act.
export const planBar = lazyComponent(() =>
  import("@/features/billing/components/plan-bar").then((m) => m.PlanBar),
);

export const SCREEN_PARTS = [
  monthForPerson,
  personLeave,
  payTab,
  displayOptions,
  missedCheckOutCard,
  planBar,
];
